import React, { useEffect } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import block from 'bem-cn'
import { useSignInForm } from 'hooks'

import { selectIsUserAuthenticated } from 'features/auth/selectors'
import { selectLocaleDict } from 'features/locale/selectors'

import { useModalContext } from '@bcraft-frontend-lib/core'

import { ModalWrapper } from 'components/ModalWrapper'
import { Button, ButtonSizes, Form, FormInput } from 'components/UIKit'

import './SignInModal.scss'

type SignInModalProps = {
  path: string
}

const b = block('sign-in-modal')

export const SignInModal: React.FC<SignInModalProps> = ({ path }) => {
  const { closeModal } = useModalContext()
  const history = useHistory()
  const isAuth = useSelector(selectIsUserAuthenticated, shallowEqual)

  const locale = useSelector(selectLocaleDict, shallowEqual).auth
  const localeCommon = useSelector(selectLocaleDict, shallowEqual).common

  useEffect(() => {
    if (isAuth) {
      history.replace('/')
    }
  }, [isAuth, history])

  const onClose = () => {
    closeModal(path)()
  }

  const { formik, isLoading } = useSignInForm({
    onSuccessCallback: onClose,
  })

  // const handleClickForgotPassword = replaceLastModal(MODAL_ROUTE_URLS.FORGOT_PASSWORD())

  return (
    <ModalWrapper title={localeCommon.logIn} className={b()} onClose={onClose} hideLogo>
      <Form className={b('form')} formik={formik}>
        <FormInput name="username" placeholder={locale.username} caption={locale.username} />
        <FormInput
          name="password"
          type="password"
          placeholder={locale.yourPassword}
          caption={locale.password}
          canBeHidden
        />

        {/* <button type="button" className={b('forgot-password')} onClick={handleClickForgotPassword}>
          {locale.forgotPassword}
        </button> */}

        <Button
          text={localeCommon.logIn}
          type="submit"
          disabled={isLoading}
          loading={isLoading}
          fullWidth
          size={ButtonSizes.LARGE}
        />
      </Form>
    </ModalWrapper>
  )
}
